import Vue from 'vue'
import VueRouter from 'vue-router'
import reportMixin from '@/mixin/reportMixin.js'
import Home from '../pages/home.vue'
import CitiesPage from '../pages/cities.vue'
import CollectionsPage from '../pages/collections.vue'
import BlogDetailPage from '../pages/blog.vue'
import ExploreCityPage from '../pages/explore-city.vue'

// 全局混入reportMixin，使所有组件都具有页面浏览上报功能
Vue.mixin(reportMixin)

Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated 开始 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated 结束 */

let routes = [
	// ─── 一级页面 ───
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: { manualPageView: true },
	},

	// ─── 固定二级页面（必须在 /:cityname 之前，防止被城市路由截获）───
	{
		// 筛选页
		path: '/cities',
		name: 'cities',
		component: CitiesPage,
	},
	{
		// 合集页
		path: '/collections',
		name: 'collections',
		component: CollectionsPage,
	},
	{
		// 博客详情页
		path: '/blog/:slug',
		name: 'blog-detail',
		component: BlogDetailPage,
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'terms',
		component: () => import('../pages/terms-of-service.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy',
		component: () => import('../pages/privacy-policy.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},

	// ─── 动态城市路由（必须放在所有固定路由之后）───
	{
		// 城市介绍页：/{cityname}/
		path: '/:cityname',
		name: 'city-detail',
		component: ExploreCityPage,
	},

	// 通配兜底
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
